/* global document */
// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withTranslator } from '@gandi/translate';

import { withForm, getFormValues } from 'gandi.react-form';

import type { FullState } from '../../../../types';

import CustomerForm from './CustomerForm';

import type {
  StateProps as CustomerFormStateProps,
  OwnProps,
} from './CustomerForm';

const selectFormValues = getFormValues(CustomerForm.FORM_ID);

const mapStateToProps = (state: FullState): CustomerFormStateProps => ({
  formValueType: selectFormValues(state)?.type,
});

const fieldsOrder: Array<string> = [
  'type',
  'name',
  'orgname',
  'firstname',
  'lastname',
  'country',
  'streetaddr',
  'streetaddr2',
  'zip',
  'city',
  'state',
  'email',
  'phone',
  'fax',
];

export default (compose(
  withTranslator({ propsNamespace: 'translator' }),
  withForm({
    form: CustomerForm.FORM_ID,
    onSubmitFail: (errors: { [field: string]: string, ... }) => {
      if (typeof document !== 'undefined') {
        const fieldsError = fieldsOrder.filter(elt => errors && errors[elt]);
        const firstField = fieldsError.shift();
        // $FlowFixMe[incompatible-call]
        const elt = document.getElementById(firstField);
        if (elt) {
          elt.focus();
        } else {
          const formElt = document.getElementById(CustomerForm.FORM_ID);
          if (formElt) {
            formElt.scrollIntoView();
          }
        }
      }
    },
  }),
  connect(mapStateToProps),
)(CustomerForm): React.ComponentType<OwnProps>);
